import useSignupContext from '@hooks/context/useSignupContext';
import { FC, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { signupIllustrationAnimation } from '@const/animation';

interface IProps {
    className?: string;
}

const Illustrations: FC<IProps> = ({ className }) => {
    const { currentIllustration } = useSignupContext();
    const [isRender, setIsRender] = useState(false);

    useEffect(() => {
        setIsRender(false);
        setTimeout(() => setIsRender(true), 0);
    }, [currentIllustration]);

    if (!isRender) return null;

    return (
        <motion.div {...signupIllustrationAnimation}>
            <img className={className} src={currentIllustration} alt="illustration" />
        </motion.div>
    );
};

export default Illustrations;
